import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const FinalCTA = () => {
  const { t } = useTranslation('home');

  return (
    <section id="final-cta" className="bg-light-gray py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="mb-5 flex items-center">
            <span aria-hidden="true" className="chalk-line" />
          </div>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold uppercase leading-none tracking-tight text-navy mb-12">
            {t('finalCta.headline')} <br />{t('finalCta.headlinePart2')}
          </h2>
        </motion.div>

        <motion.div
          className="flex flex-col sm:flex-row items-start sm:items-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Button asChild variant="cta" size="xl" className="w-full sm:w-auto">
            <Link
              to="/book-inspection"
              data-primary-cta
              onClick={() => {
                const w = window as unknown as { fbq?: (...args: unknown[]) => void };
                if (typeof window !== 'undefined' && w.fbq) {
                  w.fbq('track', 'Contact', {
                    content_name: 'Get Free Inspection Button - CTA'
                  });
                }
              }}
            >
              {t('finalCta.button')}
            </Link>
          </Button>

          <Button asChild variant="outline" size="xl" className="w-full sm:w-auto">
            <a href="tel:+13462200989">
              {t('finalCta.callButton')}
            </a>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
